import Label from "components/Label/Label";
import React, { FC, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import Textarea from "shared/Textarea/Textarea";
import CommonLayout from "./CommonLayout";
import { Helmet } from "react-helmet-async";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/store";
import axios from "axios";
import userApi from "api/user/user.api";
import SideBar from "containers/UserDashboard/SideBar";
import { HiBadgeCheck } from "react-icons/hi";
import { MdErrorOutline } from "react-icons/md";
import { FaCamera } from "react-icons/fa";
import Uploader from "containers/UserDashboard/Uploader";
export interface AccountPageProps {
  className?: string;
}

const AccountPage: FC<AccountPageProps> = ({ className = "" }) => {
  const user = useSelector((state: RootState) => state.auth.user);

  console.log({ user });

  const [displayName, setDisplayName] = useState("");
  const [gender, setGender] = useState("");
  const [username, setUsername] = useState("");
  const [birthday, setBirthday] = useState("");
  const [phone, setPhone] = useState("");
  const [bio, setBio] = useState("");
  const [photo, setPhoto] = useState("");

  const handlePhotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhoto(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpdate = async () => {
    try {
      const updatedUser = {
        _id: user?._id,
        displayName,
        username,
        gender,
        phone,
        birthday,
        bio,
        photo,
      };

      const response = await userApi.updateProfile(updatedUser);

      if (response.status === 200) {
        alert("Profile updated successfully");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Failed to update profile");
    }
  };
  console.log(user?.photo);

  const [image, setImage] = React.useState(null);

  const updateImages = (newImageUrl: any) => {
    setImage(newImageUrl);
  };

  return (
    <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
      <Helmet>
        <title>Account || Booking React Template</title>
      </Helmet>
      <SideBar>
        <div className="space-y-6 sm:space-y-8">
          {/* HEADING */}
          <h2 className="text-3xl font-semibold">Profile</h2>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-dry rounded-xl p-0 shadow-sm">
              {/* <div className="flex-shrink-0 flex items-start">
                <div className="relative rounded-full flex items-center justify-center p-1 border-2 border-red-500 ">
                  <div className="w-32 h-32 rounded-full overflow-hidden ">
                    <img
                      src={user?.photo || "default-avatar.jpg"}
                      alt="Avatar"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="absolute bottom-1 right-1 bg-white rounded-full p-1 shadow-md cursor-pointer">
                    <FaCamera className="text-gray-600" size={16} />
                  </div>

                  {user?.isVerified && (
                    <div
                      className="absolute top-1 right-1 bg-white rounded-full p-1 shadow-md"
                      title="Verified User"
                    >
                      <HiBadgeCheck className="text-green-500" size={18} />
                    </div>
                  )}

                  <input
                    type="file"
                    className="absolute inset-0 opacity-0 cursor-pointer"
                    onChange={handlePhotoChange}
                  />
                </div>
              </div> */}
              <Uploader refreshFunction={updateImages} />

              <div>
                <div>
                  <Label>Name</Label>
                  <Input
                    className="mt-1.5"
                    value={user?.displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                  />
                </div>
                <div>
                  <Label>Gender</Label>
                  <Select
                    className="mt-1.5"
                    value={user?.gender}
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </Select>
                </div>
                <Label>Email</Label>
                <Input
                  className="mt-1.5"
                  value={user?.username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled
                  rightElement={
                    user?.isVerified ? (
                      <div
                        className="flex items-center bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs font-semibold space-x-1"
                        title="Email Verified"
                      >
                        <HiBadgeCheck size={14} />
                        <span>Verified</span>
                      </div>
                    ) : (
                      <div
                        className="flex items-center bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full text-xs font-semibold space-x-1"
                        title="Email Not Verified"
                      >
                        <MdErrorOutline size={14} />
                        <span>Unverified</span>
                      </div>
                    )
                  }
                />
              </div>
            </div>
            <div className="bg-dry rounded-xl p-0 shadow-sm">
              <div className="flex flex-col md:flex-row">
                <div className="flex-grow mt-10 md:mt-0 md:pl-16 max-w-3xl space-y-6">
                  <div className="max-w-lg">
                    <Label>Date of birth</Label>
                    <Input
                      className="mt-1.5"
                      type="date"
                      value={user?.dateOfBirth}
                      onChange={(e) => setBirthday(e.target.value)}
                    />
                  </div>
                  <div>
                    <Label>Phone number</Label>
                    <Input
                      className="mt-1.5"
                      value={user?.phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>
                  <div>
                    <Label>About you</Label>
                    <Textarea
                      className="mt-1.5"
                      value={user?.bio}
                      onChange={(e) => setBio(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="pt-2">
              <ButtonPrimary onClick={handleUpdate}>Update info</ButtonPrimary>
            </div>
          </div>
        </div>
      </SideBar>
    </div>
  );
};

export default AccountPage;
